import { useRoleContext } from "./useRoleContext";
import { useSwrFetch } from "./useSwrFetch";

/*
Returns all branches and their members that the callee has access to.
Callee must have at least one BRANCH_ADMINISTRATOR role or a ADMINISTRATOR role
*/

export function useCompanyBranches() {
  const { company } = useRoleContext();

  const url =
    company?.company_type === "SHIPPER"
      ? `/companies/${company.id}/branches`
      : null;

  const { data, loading, error } = useSwrFetch<BranchMembers[]>({
    url,
    errorMessage: "Failed to fetch branches",
  });

  return {
    branches: data ?? [],
    error,
    loading,
    success: data !== undefined && error == null,
  };
}
